"use strict";
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2021 BLUECROSS BLUESHIELD OF SOUTH CAROLINA   ALL RIGHTS
 * RESERVED.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewPdf = exports.convertToUint8Array = void 0;
/**
 * Converts the PDF data to Uint8Array
 *
 * @param pdfData: ArrayBuffer | string
 * @return Uint8Array
 */
function convertToUint8Array(pdfData) {
    if (Object.prototype.toString.call(pdfData) === '[object ArrayBuffer]') {
        return new Uint8Array(pdfData);
    }
    else {
        return new Uint8Array(window.atob(pdfData).split('').map(x => x.charCodeAt(0)));
    }
}
exports.convertToUint8Array = convertToUint8Array;
/**
 * Download or Open PDF File - DEfault browser functionality
 * @param pdfArrayData
 * @param fileNameToDisplay default 'document.pdf'
 */
function viewPdf(pdfArrayData, fileNameToDisplay = 'document.pdf') {
    const blob = new Blob([pdfArrayData], { type: 'application/pdf' });
    // For IE11 and Edge
    if (navigator && navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, fileNameToDisplay);
    }
    else {
        // for all other browsers
        const link = document.createElement('a');
        document.body.appendChild(link);
        link.setAttribute('style', 'display: none');
        link.target = '_blank';
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute('download', fileNameToDisplay);
        link.click();
        URL.revokeObjectURL(url);
    }
}
exports.viewPdf = viewPdf;
//# sourceMappingURL=index.js.map